import { PresetSection } from "@/types/element-studio";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import {
  presetToPhp,
  slugToPhpSlug
} from "@/lib/elements/studio/element-to-php";
import * as t from "io-ts";
import slugify from "slugify";
import { getItemNamespaceFromSlug } from "@/lib/elements/studio/misc";

export async function savePresetToServer(
  preset: PresetSection,
  directoryPath: string,
  filename: string,
  slug: string
) {
  return await makeWordPressAjaxRequest({
    action: "breakdance_save_preset",
    dataToPost: {
      directoryPath,
      filename,
      preset: presetToPhp(
        slugToPhpSlug(slug),
        preset.section,
        getItemNamespaceFromSlug(slug)
      )
    },
    decoder: t.unknown
  });
}

export function getSlugFromNamespaceAndFilename(
  namespace: string,
  filename: string
) {
  return `${namespace}\\${slugify(filename)}`;
}
